import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class ConfirmDialogService {
  private subject = new Subject<any>();
  private subject_withclose = new Subject<any>();

  // Exposed API for components to use (optional convenience wrapper)
  confirmThis(
    title: string,
    message: string,
    yesFn: () => void,
    noFn: () => void,
    confirmationTextRequired: boolean = false,
    requiredText: string = 'DELETE'
  ): any {
    this.setConfirmation(title, message, yesFn, noFn, confirmationTextRequired, requiredText);
  }

  confirmThis_withClose(
    title: string,
    message: string,
    yesFn: () => void,
    noFn: () => void,
    closeFn: () => void,
    confirmationTextRequired: boolean = false,
    requiredText: string = 'DELETE'
  ): any {
    this.setConfirmation_withclose(title, message, yesFn, noFn, closeFn, confirmationTextRequired, requiredText);
  }

  // Core implementation for basic confirmation modal
  setConfirmation(
    title: string,
    message: string,
    yesFn: () => void,
    noFn: () => void,
    confirmationTextRequired: boolean = false,
    requiredText: string = 'DELETE'
  ): any {
    const that = this;
    this.subject.next({
      type: 'confirm',
      text: message,
      title: title,
      confirmationTextRequired,
      requiredText,
      yesFn(): any {
        that.subject.next(null); // Close modal
        yesFn();
      },
      noFn(): any {
        that.subject.next(null);
        noFn();
      }
    });
  }

  // Core implementation for confirmation modal with a close handler
  setConfirmation_withclose(
    title: string,
    message: string,
    yesFn: () => void,
    noFn: () => void,
    closeFn: () => void,
    confirmationTextRequired: boolean = false,
    requiredText: string = 'DELETE'
  ): any {
    const that = this;
    this.subject_withclose.next({
      type: 'confirm',
      text: message,
      title: title,
      confirmationTextRequired,
      requiredText,
      yesFn(): any {
        that.subject_withclose.next(null);
        yesFn();
      },
      noFn(): any {
        that.subject_withclose.next(null);
        noFn();
      },
      closeFn(): any {
        that.subject_withclose.next(null);
        closeFn();
      }
    });
  }

  // Observables for subscribing to messages
  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }

  getMessage_withclose(): Observable<any> {
    return this.subject_withclose.asObservable();
  }
}
